export function isDeviceOnline(timestamp) {
  if (!timestamp) return false;
  const lastSeen = parseTimestamp(timestamp);
  const now = new Date();
  const diffInMinutes = (now - lastSeen) / 1000 / 60;
  // Treat the device as online if the last update was within the last
  // five minutes. Using a non-strict comparison avoids a brief offline
  // state when updates arrive exactly every five minutes.
  return diffInMinutes <= 5;
}

export function formatDeviceTimestamp(timestamp, locale = undefined) {
  if (!timestamp) return '-';
  const date = parseTimestamp(timestamp);
  return date.toLocaleString(locale, { hour12: false });
}

export function parseTimestamp(val) {
  const n = Number(val);
  if (!Number.isNaN(n)) {
    const ms = n < 1e12 ? n * 1000 : n;
    return new Date(ms);
  }
  return new Date(val);
}

export function formatChartSampleTime(timestamp, locale = 'en-GB') {
  const d = parseTimestamp(timestamp);
  if (!Number.isFinite(d.getTime())) return '';
  return d.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatChartQuarterHourTime(timestamp, locale = 'en-GB') {
  const d = parseTimestamp(timestamp);
  if (!Number.isFinite(d.getTime())) return '';
  const aligned = new Date(d.getTime());
  aligned.setMinutes(Math.round(aligned.getMinutes() / 15) * 15, 0, 0);
  return aligned.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatChartTooltipTime(timestamp, locale = 'en-GB') {
  const d = parseTimestamp(timestamp);
  if (!Number.isFinite(d.getTime())) return '';
  const aligned = new Date(d.getTime());
  aligned.setMinutes(Math.round(aligned.getMinutes() / 15) * 15, 0, 0);
  return aligned.toLocaleString(locale, {
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/**
 * Legacy chart axis formatting: local time floored to the start of the hour (… HH:00), 24h.
 */
export function formatChartRoundHourTime(timestamp, locale = 'en-GB') {
  const d = parseTimestamp(timestamp);
  if (!Number.isFinite(d.getTime())) return '';
  const floored = new Date(d.getTime());
  floored.setMinutes(0, 0, 0);
  return floored.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/** Skip repeated identical labels (e.g. many samples in the same hour). */
export function formatChartAxisTimeSuppressDuplicates(labels, index) {
  if (!Array.isArray(labels) || index < 0) return '';
  const lbl = labels[index];
  if (lbl == null || lbl === '') return '';
  if (index > 0 && labels[index - 1] === lbl) return '';
  return lbl;
}

